// services
import useInputHelper from './inputHelper';
import { DefaultInputPropTypes } from './types';
import useFormValidation from '../useFormValidation';

export interface CurrencyInputProps extends DefaultInputPropTypes<string | number> {
  endAdornment?: React.ReactNode;
  maxDecimal?: number;
  maxInteger?: number;
  allowNegative?: boolean;
  formatInitialValue?: (value?: StringOrNumber) => StringOrNumber;
  autocomplete?: 'off';
  suffix?: string;
  isControlledValue?: boolean;
  allowDecimal?: boolean;
}

const useCurrencyInputHelper = ({ maxDecimal, maxInteger, ...props }: CurrencyInputProps) => {
  const inputHelper = useInputHelper(props);
  const { getMaxDecimal, getMaxInteger } = useFormValidation(props.source);

  return {
    ...inputHelper,
    getMaxDecimal: () => maxDecimal ?? getMaxDecimal(),
    getMaxInteger: () => maxInteger ?? getMaxInteger(),
  };
};

export default useCurrencyInputHelper;
